import { $api } from '@service/RequestService';
import { timeStampToDate } from '@utils/index';
import { OneLid } from '@utils/models/OneLid';
import { Pagination } from '@utils/models/Pagination';
import { stringifyUrl } from 'query-string';
import { useInfiniteQuery } from 'react-query';

import { crmConstants } from '..';

export const useGlobalDuplicateControlSearchAllDuplicate = (
  props: {
    pageOfDuplicate?: number;
    page?: number;
    size?: number;
    pipeIds?: number[];
    enabled?: boolean;
  } = {}
) => {
  const { page, pageOfDuplicate, size = 5, enabled, ...args } = props;

  return useInfiniteQuery<Pagination<OneLid>>({
    queryKey: [crmConstants.queryKeys.GLOBAL_DUPLICATE_CONTROL_SEARCH_ALL_DUPLICATE, props],
    queryFn: async ({ pageParam = 1 }) => {
      const res = await $api.post(
        stringifyUrl({
          url: '/v1/global-duplicate-control/search-all-duplicate',
          query: {
            page: pageParam,
            pageOfDuplicate,
            size
          }
        }),
        { ...args }
      );

      const data: Pagination<OneLid> = res?.data;

      return data
        ? {
            ...data,
            data: data?.data?.map(item => ({
              ...item,
              createdDate: timeStampToDate({
                date: item?.createdDate!,
                timeStamp: item?.createdTimestamp
              }),
              deletedDate: timeStampToDate({
                date: item?.deletedDate!,
                timeStamp: item?.deletedTimestamp
              })
            }))
          }
        : data;
    },
    getNextPageParam: (lastPage, page) => {
      if (page.length < lastPage?.totalElements / size) {
        return page.length + 1;
      }
      return undefined;
    },
    enabled
  });
};
